module.exports = __webpack_public_path__ + "img/product9.898b9f4c.jpg";